/**
 * MH14-04b — "fechado nesta sessao" do pop-up de videos obrigatorios.
 *
 * O servidor manda a fila em toda entrada enquanto houver aula nao assistida; fechar e
 * "Ver depois" so escondem o pop-up ate o fim da sessao. Sessao = esta aba
 * (`sessionStorage` sobrevive ao F5, morre com a aba) ate o logout ou o refresh recusado
 * (`clearSessionData`). Guarda o id do aluno: outro login na mesma aba ve o pop-up.
 */
const STORAGE_KEY = 'medhunter-first-access-dismissed'

function storage(): Storage | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage
  } catch {
    // Storage bloqueado (aba privada, cookies desligados): o pop-up so some ate o F5
    return null
  }
}

export function isFirstAccessDismissed(userId: number | undefined): boolean {
  if (userId === undefined) return false
  return storage()?.getItem(STORAGE_KEY) === String(userId)
}

export function dismissFirstAccess(userId: number | undefined): void {
  if (userId === undefined) return
  try {
    storage()?.setItem(STORAGE_KEY, String(userId))
  } catch {
    // Cota estourada: o pop-up so some ate o F5
  }
}

export function clearFirstAccessDismissal(): void {
  try {
    storage()?.removeItem(STORAGE_KEY)
  } catch {
    // Nada a limpar
  }
}
